/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfigurationResponse } from '../models/configuration-response';
import { createOptsConfigurations } from '../fn/opts-configurations/create-opts-configurations';
import { CreateOptsConfigurations$Params } from '../fn/opts-configurations/create-opts-configurations';
import { getOptsConfigurations } from '../fn/opts-configurations/get-opts-configurations';
import { GetOptsConfigurations$Params } from '../fn/opts-configurations/get-opts-configurations';
import { updateOptsConfigurations } from '../fn/opts-configurations/update-opts-configurations';
import { UpdateOptsConfigurations$Params } from '../fn/opts-configurations/update-opts-configurations';

@Injectable({ providedIn: 'root' })
export class OptsConfigurationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOptsConfigurations()` */
  static readonly GetOptsConfigurationsPath = '/stores/{storeId}/preptimes';

  /**
   * Gets OPTS configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOptsConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOptsConfigurations$Response(params: GetOptsConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationResponse>> {
    return getOptsConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets OPTS configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOptsConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOptsConfigurations(params: GetOptsConfigurations$Params, context?: HttpContext): Observable<ConfigurationResponse> {
    return this.getOptsConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigurationResponse>): ConfigurationResponse => r.body)
    );
  }

  /** Path part for operation `updateOptsConfigurations()` */
  static readonly UpdateOptsConfigurationsPath = '/stores/{storeId}/preptimes';

  /**
   * Updates OPTS configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOptsConfigurations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOptsConfigurations$Response(params: UpdateOptsConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationResponse>> {
    return updateOptsConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates OPTS configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOptsConfigurations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOptsConfigurations(params: UpdateOptsConfigurations$Params, context?: HttpContext): Observable<ConfigurationResponse> {
    return this.updateOptsConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigurationResponse>): ConfigurationResponse => r.body)
    );
  }

  /** Path part for operation `createOptsConfigurations()` */
  static readonly CreateOptsConfigurationsPath = '/stores/{storeId}/preptimes';

  /**
   * Create OPTS configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOptsConfigurations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOptsConfigurations$Response(params: CreateOptsConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationResponse>> {
    return createOptsConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Create OPTS configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOptsConfigurations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOptsConfigurations(params: CreateOptsConfigurations$Params, context?: HttpContext): Observable<ConfigurationResponse> {
    return this.createOptsConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigurationResponse>): ConfigurationResponse => r.body)
    );
  }

}
